<template>
  <span>{{ (time / 1000).toFixed(1) }}s</span>
</template>

<script>
export default {
  props: ['run'],
  data () {
    return {
      timer: null,
      start: 0,
      time: 0
    }
  },
  watch: {
    run (val) {
      if (val) {
        clearTimeout(this.timer)
        this.start = Date.now()
        this.startTimer()
      } else {
        clearTimeout(this.timer)
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    startTimer () {
      this.time = Date.now() - this.start
      if (this.run) {
        this.timer = setTimeout(this.startTimer, 100)
      }
    }
  }
}
</script>

<style scoped>

</style>
